// src/pages/FinancePage/components/company/utils.ts

export function formatCurrency(value: number, currency = 'COP'): string {
    return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
}

export function formatCurrencyCompact(value: number): string {
    const abs = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    if (abs >= 1_000_000) {
        return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
    }
    if (abs >= 1_000) {
        return `${sign}$${(abs / 1_000).toFixed(0)}K`;
    }
    return `${sign}$${abs.toFixed(0)}`;
}

export function formatPercentage(value: number, decimals = 1): string {
    return `${value.toFixed(decimals)}%`;
}

export function formatMultiplier(value: number): string {
    return `${value.toFixed(1)}x`;
}

export function formatNumber(value: number): string {
    return new Intl.NumberFormat('es-CO').format(value);
}

export function formatShortDate(value: Date | string): string {
    const date = typeof value === 'string' ? new Date(`${value}T00:00:00`) : value;
    return new Intl.DateTimeFormat('es-CO', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(date);
}

export function formatDateRange(from: Date | string, to: Date | string): string {
    return `${formatShortDate(from)} - ${formatShortDate(to)}`;
}

// Cálculo del % de caída entre dos etapas del funnel
export function calculateConversion(from: number, to: number): number {
    if (from === 0) return 0;
    return (to / from) * 100;
}
